import React from 'react';
import { useLocation } from 'react-router-dom';

/** Fades/slides main route content on navigation (respects reduced motion via CSS). */
export default function PageTransition({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="e2s-page-enter">
      {children}
    </div>
  );
}
